// extracted by mini-css-extract-plugin
export var messageSideLeft = "_k3-1";
export var messageSideRight = "_k3-2";
export var subscribeToBackInStockBubbleContainer = "_k3-0";